export default __webpack_public_path__ + "img/shape-hexagon.ab4490f4.svg";